import { useState, useEffect } from "react";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import Axios from "../../../../config/axios";
import AdherenceWheels from "../../../adherenceWheels";

const AdherenceContainer = ({ patientId, protocolId, software, sessionTimeRange, setSessionTimeRange, sessionsData = [], plotsRef }) => {
  const [adherenceObject, setAdherenceObject] = useState({});

  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/adherence/protocol/get/${patientId}/${protocolId}/${software}/${sessionTimeRange}`)
      .then(({ data }) => {
        setAdherenceObject(data);
      })
      .catch((error) => {
        console.log("Get protocol adherence: ", error);
      });
  }, [patientId, protocolId, software, sessionTimeRange]);

  return (
    <AdherenceWheels
      adherenceObject={adherenceObject}
      sessionTimeRange={sessionTimeRange}
      setSessionTimeRange={setSessionTimeRange}
      sessionsData={sessionsData}
      showFilesDownload={true}
      plotsRef={plotsRef}
    />
  );
};

export default AdherenceContainer;
